import Button from './Button';

interface ErrorStateProps {
  title: string;
  description?: string;
  retryLabel?: string;
  onRetry: () => void;
  compact?: boolean;
}

export default function ErrorState({
  title,
  description,
  retryLabel = 'Retry',
  onRetry,
  compact = false,
}: ErrorStateProps) {
  return (
    <div
      role="alert"
      className={`flex flex-col items-center justify-center rounded-lg border border-rose-200 bg-rose-50/60 px-6 text-center ${
        compact ? 'py-6' : 'py-10'
      }`}
    >
      <span className="w-12 h-12 flex items-center justify-center rounded-full bg-rose-100 text-rose-600 mb-3">
        <i className="ri-error-warning-line text-2xl leading-none" aria-hidden="true" />
      </span>
      <p className="text-sm font-semibold text-rose-800">{title}</p>
      {description ? <p className="mt-1 max-w-md text-sm text-rose-700/80">{description}</p> : null}
      <Button
        variant="danger-outline"
        size="sm"
        className="mt-4"
        icon="ri-refresh-line"
        onClick={onRetry}
      >
        {retryLabel}
      </Button>
    </div>
  );
}